export function _driverStatus(status: string) {
    const states: any = {
        AWAIT: "Aguardando aprovação",
        DISAPPROVED: "Reprovado",
        APPROVED: "Aprovado",
        RETENTIVE: "Retentativa",
    };

    return states[status];
}

export function _userRole(role: string) {
    const roles: any = {
        ROLE_MASTER: "Master",
        ROLE_GESTOR: "Gestor",
        ROLE_AUDITOR: "Auditor",
        ROLE_ADMINISTRATIVO: "Administrativo",
    };

    return roles[role];
}

export function _reasonType(type: string) {
    const types: any = {
        DRIVER: "Motorista",
        PASSENGER: "Passageiro",
    };

    return types[type];
}

export function _reasonPage(page: string) {
    const pages: any = {
        CANCELLATION: "Cancelamento",
        SUPPORT: "Suporte",
    };

    return pages[page];
}
